Vue.component("MpModuleNewsletter", {
    mixins: [MpMailchimpSubscription],

    data: function() {
        return {
            isLegalShown: false,
        };
    },

    computed: {

        legalTriggerLabel: function() {
            return (this.isLegalShown) ? this.LABEL_LEGAL_INFO_HIDE : this.LABEL_LEGAL_INFO_SHOW;
        },

        hasTitleContent: function() {
            return (!!this.$slots.title || !!this.$scopedSlots.title);
        },

        hasIntroContent: function() {
            return (!!this.$slots.intro || !!this.$scopedSlots.intro);
        },
    },

    methods: {

        onCookieNewsletterSaved: function() {
            // Custom mixin implementation, not required for this class
        },

        toggleLegalConditions: function(ev) {
            this.isLegalShown = !this.isLegalShown;
        },


        init: function() {}
    },

    mounted: function() {
        this.init();
    },

    updated: function() {},

    template: '\
    <div class="newsletter-promo">\
        <div class="row">\
            <div class="col-auto d-none d-lg-block">\
                <div class="newsletter-promo__icon icon icon--xl">\
                    <svg class="icon__inner" width="64" height="64" viewBox="0 0 64 64" fill="none" xmlns="http://www.w3.org/2000/svg"><path d="M58.042 22.545v-.005l-.017-.012-.003-.003h-.002l-7.353-4.645v-7.547A1.334 1.334 0 0049.332 9H14.667a1.334 1.334 0 00-1.335 1.332v7.548L5.98 22.523h-.002l-.003.002-.017.013.002.005-.002.002a1.33 1.33 0 00-.625 1.122V53a1.334 1.334 0 001.335 1.333h50.665A1.335 1.335 0 0058.667 53V23.668a1.33 1.33 0 00-.625-1.123zm-3.372 1.017l-4.003 2.108v-4.638l4.003 2.53zM48 11.668v15.405l-16 8.42-16-8.42V11.668h32zM13.332 25.67L9.33 23.562l4.002-2.53v4.638zM56 51.667H8V25.875L31.38 38.18c.387.205.852.205 1.24 0L56 25.875v25.792z" fill="currentColor"/><path d="M22.668 19.666h18.665a1.335 1.335 0 100-2.667H22.668a1.334 1.334 0 100 2.668zM22.668 25h18.665a1.334 1.334 0 100-2.668H22.668a1.335 1.335 0 100 2.668z" fill="currentColor"/></svg>\
                </div>\
            </div>\
            <div class="col">\
                <slot name="title">\
                    <h5 class="newsletter-promo__title"></h5>\
                </slot>\
                <slot name="intro">\
                    <p class="newsletter-promo__text"></p>\
                </slot>\
\
                <div class="newsletter-promo__form">\
                    <form class="newsletter__form form" action="https://mundopetroleo.us12.list-manage.com/subscribe/post-json" method="get" ref="mcform">\
                        <input type="hidden" name="b_f760987f51ffd7d4bc0d46264_1f1a07a14d" tabindex="-1" value="">\
                        <div class="row align-items-center">\
                            <div class="col newsletter__form-group mc-field-group">\
                                <input class="newsletter__form-control form-control required email" type="email" value="" name="EMAIL" id="mce-EMAIL" placeholder="Introduzca su correo electrónico" v-model="email">\
                                </div>\
                            <div class="col-auto">\
                                <a class="newsletter__form-btn btn btn--tertiary u-text-uppercase" @click.prevent="doSubscription()">Suscribirme</a>\
                            </div>\
                        </div>\
                        <p class="newsletter__message newsletter__message--left newsletter__message--ok" v-show="successMessage">{{successMessage}}</p>\
                        <p class="newsletter__message newsletter__message--left newsletter__message--ko" v-show="errorMessage" v-html="errorMessage"></p>\
                    </form>\
                </div>\
\
                <div class="newsletter-promo__legal" :class="{\'newsletter-promo__legal--closed\': !isLegalShown}">\
                    <h5 class="newsletter-promo__legal-trigger" @click="toggleLegalConditions"><span class="u-mr-xxxs">⚠️</span> {{legalTriggerLabel}}</h5>\
                    <div class="newsletter-promo__legal-conditions">\
                        <p>Según normativa actual de Protección de Datos de Carácter Personal, se informa que el Responsable del Tratamiento de sus datos es MUNDOPETROLEO PETRORED, SL. Sus datos serán tratados con la finalidad de enviarle el boletín emitido por nuestra entidad o las noticias y servicios que puedan ser interesantes para su entidad. La legitimación está basada en el consentimiento por parte del interesado. No se cederán datos a terceros, salvo obligación legal. Los datos serán destruidos una vez que comunique usted su baja o finalizados los períodos legales de conservación. En caso de utilizar servicios de marketing externos, sus datos podrán ser cedidos a empresas prestadoras de servicios de marketing por correo electrónico las cuales se encuentran adheridas al escudo de PRIVACY SHIELD.</p>\
                        <p class="u-mb-0">Los interesados podrán ejercitar sus derechos de acceso, rectificación, supresión, oposición, portabilidad o limitación del tratamiento, dirigi&eacute;ndose a&nbsp; MUNDOPETROLEO PETRORED, SL en la siguiente dirección: Polígono de Salcedo II, Parc. D3, Navia (33710), Asturias, España.&nbsp; Igualmente, puede presentar una reclamación ante la Agencia Espa&ntilde;ola de Protección de datos si considera que sus derechos han sido vulnerados.</p>\
                    </div>\
                </div>\
            </div>\
        </div>\
    </div>',
});